import { chooseIndefiniteArticle } from 'util/strings'

const getLinkText = provider => {
  if (provider === 'github') return 'GitHub issue'
  return 'Unknown integration'
}

const IntegrationAction = action => {
  const { change: { provider, removed, title, url } = {} } = action
  if (provider === 'hubspot') {
    return (
      <React.Fragment>
        <span className="action-verb">created</span> {title} as a{' '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          contact
        </a>
      </React.Fragment>
    )
  }

  if (provider === 'salesforce') {
    return (
      <React.Fragment>
        <span className="action-verb">created</span> {title} as a{' '}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          lead
        </a>
      </React.Fragment>
    )
  }

  if (['github', 'jira_cloud', 'jira_server', 'trello'].includes(provider)) {
    return (
      <React.Fragment>
        {removed ? (
          <span>
            <span className="action-verb">unlinked</span> this conversation from{' '}
          </span>
        ) : (
          <span>
            <span className="action-verb">linked</span> this conversation to{' '}
          </span>
        )}
        <a target="_blank" rel="noopener noreferrer" href={url}>
          {title}
        </a>
      </React.Fragment>
    )
  }

  const linkText = getLinkText(provider)
  const direction = removed ? (
    <span>
      <span className="action-verb">removed</span> this from
    </span>
  ) : (
    <span>
      <span className="action-verb">added</span> this to
    </span>
  )
  const base = `${direction} ${chooseIndefiniteArticle(linkText)} `

  return (
    <React.Fragment>
      {base}
      <a target="_blank" rel="noopener noreferrer" href={url}>
        {linkText}
      </a>
    </React.Fragment>
  )
}

export default IntegrationAction
